module.exports = __webpack_public_path__ + "static/media/fff_about_jobs.9ecd7fb8.png";